import { hasOztPrefix } from '../components/InterfaceAppIntegrations/component/consts/ozonetel/shared';
import { hasPusherPrefix } from '../components/InterfaceAppIntegrations/component/consts/pusher/shared';
import { PAGE_EVENT_PREFIX } from '../const';

export const PAGE_EVENT_GROUP_ID = {
  DEFAULT: 'default',
  PAGE: 'page',
  OZONETEL: 'ozonetel',
  PUSHER: 'pusher',
} as const;

export const getPageEventGroupId = (eventType?: string) => {
  if (hasOztPrefix(eventType)) {
    return PAGE_EVENT_GROUP_ID.OZONETEL;
  }

  if (hasPusherPrefix(eventType)) {
    return PAGE_EVENT_GROUP_ID.PUSHER;
  }

  if (eventType?.startsWith(PAGE_EVENT_PREFIX)) {
    return PAGE_EVENT_GROUP_ID.PAGE;
  }

  return PAGE_EVENT_GROUP_ID.DEFAULT;
};
